"use strict";

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.number.is-nan");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getStateMedianFamilyIncome;
/* eslint-disable object-curly-newline */

function getStateMedianFamilyIncome(dirtyState, persons) {
  if (!dirtyState) throw new Error('Missing State');
  var state = dirtyState.toUpperCase();
  if (!persons || persons === 0 || Number.isNaN(persons)) throw new Error('Missing Persons Count'); // https://www.justice.gov/ust/eo/bapcpa/20171101/bci_data/median_income_table.htm

  var medianMap = {
    AL: {
      1: 47680,
      2: 55905,
      3: 67334,
      4: 81514
    },
    AK: {
      1: 62858,
      2: 76208,
      3: 100494,
      4: 101221
    },
    AZ: {
      1: 51388,
      2: 64543,
      3: 70428,
      4: 85403
    },
    AR: {
      1: 42461,
      2: 52986,
      3: 57221,
      4: 72767
    },
    CA: {
      1: 59286,
      2: 77860,
      3: 86665,
      4: 99512
    },
    CO: {
      1: 60819,
      2: 79711,
      3: 92517,
      4: 105947
    },
    CT: {
      1: 65502,
      2: 87017,
      3: 99857,
      4: 123477
    },
    DE: {
      1: 54589,
      2: 71351,
      3: 83079,
      4: 100799
    },
    DC: {
      1: 62285,
      2: 113034,
      3: 127467,
      4: 138112
    },
    FL: {
      1: 50641,
      2: 61619,
      3: 67717,
      4: 81091
    },
    GA: {
      1: 49236,
      2: 63850,
      3: 72426,
      4: 85763
    },
    HI: {
      1: 64803,
      2: 76240,
      3: 98829,
      4: 112345
    },
    ID: {
      1: 51189,
      2: 60814,
      3: 66222,
      4: 76536
    },
    IL: {
      1: 53900,
      2: 71301,
      3: 82268,
      4: 101240
    },
    IN: {
      1: 47965,
      2: 61811,
      3: 72228,
      4: 86076
    },
    IA: {
      1: 50661,
      2: 67897,
      3: 77525,
      4: 93880
    },
    KS: {
      1: 50944,
      2: 66025,
      3: 75629,
      4: 87119
    },
    KY: {
      1: 43800,
      2: 55256,
      3: 65544,
      4: 78689
    },
    LA: {
      1: 44822,
      2: 54424,
      3: 61917,
      4: 80818
    },
    ME: {
      1: 50537,
      2: 63734,
      3: 76984,
      4: 93912
    },
    MD: {
      1: 69529,
      2: 88815,
      3: 104390,
      4: 125989
    },
    MA: {
      1: 65924,
      2: 82628,
      3: 106206,
      4: 132026
    },
    MI: {
      1: 52168,
      2: 63281,
      3: 76825,
      4: 91986
    },
    MN: {
      1: 57017,
      2: 76319,
      3: 95919,
      4: 112291
    },
    MS: {
      1: 41659,
      2: 50980,
      3: 57431,
      4: 68491
    },
    MO: {
      1: 48212,
      2: 60424,
      3: 72543,
      4: 90489
    },
    MT: {
      1: 50165,
      2: 63278,
      3: 73586,
      4: 85739
    },
    NE: {
      1: 48796,
      2: 68061,
      3: 77274,
      4: 93746
    },
    NV: {
      1: 51516,
      2: 64586,
      3: 73524,
      4: 80077
    },
    NH: {
      1: 65400,
      2: 78998,
      3: 100278,
      4: 120342
    },
    NJ: {
      1: 68464,
      2: 82249,
      3: 104752,
      4: 128994
    },
    NM: {
      1: 44833,
      2: 55325,
      3: 59538,
      4: 66358
    },
    NY: {
      1: 56120,
      2: 71349,
      3: 86670,
      4: 105636
    },
    NC: {
      1: 47904,
      2: 60946,
      3: 67931,
      4: 85948
    },
    ND: {
      1: 52357,
      2: 79459,
      3: 86261,
      4: 97559
    },
    OH: {
      1: 50384,
      2: 63514,
      3: 76260,
      4: 91580
    },
    OK: {
      1: 48322,
      2: 58436,
      3: 65400,
      4: 75326
    },
    OR: {
      1: 55943,
      2: 70559,
      3: 79262,
      4: 97311
    },
    PA: {
      1: 53633,
      2: 66338,
      3: 82375,
      4: 101477
    },
    RI: {
      1: 60608,
      2: 74508,
      3: 83585,
      4: 102967
    },
    SC: {
      1: 46642,
      2: 60434,
      3: 65410,
      4: 79780
    },
    SD: {
      1: 47053,
      2: 67817,
      3: 69074,
      4: 82331
    },
    TN: {
      1: 47361,
      2: 59829,
      3: 68493,
      4: 78283
    },
    TX: {
      1: 49996,
      2: 65708,
      3: 72632,
      4: 84724
    },
    UT: {
      1: 63653,
      2: 67778,
      3: 81167,
      4: 91810
    },
    VT: {
      1: 56829,
      2: 74256,
      3: 80232,
      4: 101783
    },
    VA: {
      1: 60925,
      2: 77999,
      3: 90358,
      4: 110000
    },
    WA: {
      1: 66309,
      2: 78823,
      3: 90921,
      4: 105568
    },
    WV: {
      1: 48183,
      2: 51102,
      3: 63137,
      4: 74916
    },
    WI: {
      1: 51792,
      2: 67146,
      3: 82119,
      4: 98317
    },
    WY: {
      1: 60985,
      2: 72964,
      3: 76916,
      4: 96120
    },
    // U.S. Territories
    GU: {
      1: 42009,
      2: 50229,
      3: 57238,
      4: 69265
    },
    MP: {
      1: 28211,
      2: 28211,
      3: 32821,
      4: 48273
    },
    PR: {
      1: 24261,
      2: 24261,
      3: 25560,
      4: 33501
    },
    VI: {
      1: 33331,
      2: 40059,
      3: 42712,
      4: 46794
    }
  };
  return medianMap[state][persons > 4 ? 4 : persons] + (persons > 4 ? (persons - 4) * 9000 : 0);
}